"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class OfferFeedbackPathRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: '780e2de9-f3f3-4feb-967e-357543a5a8b0', description: 'UUID of the offer.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackPathRequest.prototype, "offerId", void 0);
exports.default = OfferFeedbackPathRequest;
